import { useIsMobile } from "../../hooks/useIsMobile";
import ContractMarkdown from "./ContractMarkdown";
import { bySummaryNum, fmtDate } from "./shared";

export default function CorrespondenceTimelineFlyout({ documents, aiSummaries, typePrefixBase, projectName, onClose }) {
  const entries = (documents || [])
    .map(doc => {
      const typePrefix = `${typePrefixBase}_doc_${doc.TurnoverDocumentID}`;
      const body = (aiSummaries || [])
        .filter(s => s.SummaryType?.startsWith(typePrefix + "_s"))
        .sort(bySummaryNum)
        .map(s => s.SummaryText)
        .join("\n\n");
      if (!body) return null;
      const dateValue = doc.DocDate ? Date.parse(doc.DocDate) : NaN;
      return {
        fileName:   doc.FileName,
        dateLabel:  doc.DocDate ? fmtDate(doc.DocDate) : null,
        dateValue:  isNaN(dateValue) ? null : dateValue,
        body,
      };
    })
    .filter(Boolean)
    .map((e, i) => ({ ...e, i }))
    .sort((a, b) => {
      if (a.dateValue == null && b.dateValue == null) return a.i - b.i;
      if (a.dateValue == null) return 1;
      if (b.dateValue == null) return -1;
      return a.dateValue - b.dateValue;
    });

  const isMobile = useIsMobile();

  return (
    <>
      <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.25)", zIndex: 299 }} />
      <div style={{
        position: "fixed", top: 0, right: 0, width: isMobile ? "100%" : 620, height: "100vh",
        background: "#f8fafc", borderLeft: isMobile ? "none" : "1px solid var(--cs-border)",
        boxShadow: "-4px 0 32px rgba(0,0,0,0.12)", zIndex: 300,
        display: "flex", flexDirection: "column",
      }}>
        <div style={{ padding: isMobile ? "14px 16px" : "16px 22px", borderBottom: "1px solid var(--cs-border)", flexShrink: 0, background: "#0c4a6e" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
            <div>
              <div style={{ fontSize: 15, fontWeight: 700, color: "#fff" }}>🕐 Correspondence Timeline</div>
              <div style={{ fontSize: 12, color: "#93c5fd", marginTop: 3 }}>{projectName}</div>
            </div>
            <button onClick={onClose} style={{ background: "rgba(255,255,255,0.1)", border: "none", cursor: "pointer", fontSize: 18, color: "#fff", lineHeight: 1, padding: "4px 8px", borderRadius: 6 }}>✕</button>
          </div>
        </div>
        <div style={{ flex: 1, overflowY: "auto", padding: isMobile ? "16px" : "20px 24px" }}>
          {entries.length === 0 ? (
            <div style={{ color: "var(--text3)", fontSize: 13, textAlign: "center", marginTop: 40 }}>
              No analyzed correspondence yet — click "Analyze ↗" on a document to add it to the timeline.
            </div>
          ) : (
            <div style={{ position: "relative", paddingLeft: 22 }}>
              <div style={{ position: "absolute", left: 6, top: 6, bottom: 6, width: 2, background: "#bae6fd" }} />
              {entries.map((e, idx) => (
                <div key={idx} style={{ position: "relative", marginBottom: 22 }}>
                  <div style={{
                    position: "absolute", left: -22, top: 4, width: 12, height: 12, borderRadius: "50%",
                    background: "#0ea5e9", border: "2px solid #fff", boxShadow: "0 0 0 1px #bae6fd",
                  }} />
                  <div style={{ display: "flex", alignItems: "baseline", gap: 10, marginBottom: 6 }}>
                    {e.dateLabel ? (
                      <span style={{ fontSize: 11, fontWeight: 700, color: "#0369a1", background: "#e0f2fe", padding: "2px 8px", borderRadius: 100, whiteSpace: "nowrap" }}>
                        {e.dateLabel}
                      </span>
                    ) : (
                      <span style={{ fontSize: 11, fontWeight: 700, color: "#92400e", background: "#fef3c7", padding: "2px 8px", borderRadius: 100, whiteSpace: "nowrap" }}>
                        No date
                      </span>
                    )}
                    <span style={{ fontSize: 13, fontWeight: 700, color: "var(--text)" }}>{e.fileName}</span>
                  </div>
                  <div style={{ background: "#fff", border: "1px solid var(--cs-border)", borderRadius: 8, padding: "12px 16px" }}>
                    <ContractMarkdown text={e.body} />
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
